import React, { useCallback, useEffect, useState } from 'react';

import { Route, Switch, useParams, useRouteMatch as useRouteMatchBase } from 'react-router-dom';

import { ApplicationClientLayout } from 'components/modules/ApplicationClientLayout';
import { ApplicationLayout } from 'components/modules/ApplicationLayout';
import { Insurance } from 'components/modules/Insurance/Insurance';
import { Insurance as InsuranceRoutes } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';
import { featureFlags, FEATURES } from 'utils/feature-flags';
import { uuidObject } from 'utils/uuid';

const { CREATE_NEW_BASE_PATHNAME, EDIT_BASE_PATHNAME } = InsuranceRoutes;

export const Application = () => {
  const params = useParams();
  const { path } = useRouteMatchBase();
  const [isCreateNewPage, setIsCreateNewPage] = useState(path.includes('/worksheet/create-new'));
  // eslint-disable-next-line no-unused-vars
  const [sessionId, setSessionId] = useState();

  const isCreateNewInsuranceRoutes = Boolean(useRouteMatch(CREATE_NEW_BASE_PATHNAME));
  const isEditInsuranceRoutes = Boolean(useRouteMatch(EDIT_BASE_PATHNAME));
  const isEnabledFeatureFlag = featureFlags.enabled(FEATURES.UI_INSURANCE_2);
  const isInsuranceRoutes =
    isEnabledFeatureFlag && (isCreateNewInsuranceRoutes || isEditInsuranceRoutes);

  const renderRouteChildren = useCallback(() => {
    if (isInsuranceRoutes) {
      return <Insurance />;
    }

    return <ApplicationClientLayout />;
  }, [isInsuranceRoutes]);

  useEffect(() => {
    return () => {
      uuidObject.set();
    };
  }, []);

  useEffect(() => {
    if (params?.id !== sessionId) {
      setSessionId(params?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id]);

  useEffect(() => {
    if (isCreateNewPage) {
      uuidObject.set();
    }
  }, [isCreateNewPage]);

  useEffect(() => {
    if (sessionId && !isCreateNewPage) {
      uuidObject.set();
      setIsCreateNewPage(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <Switch>
      <Route path="/worksheet/:id/credit/anketa" exact>
        <ApplicationLayout />
      </Route>
      <Route
        path={[
          '/worksheet/create-new/calculator',
          '/worksheet/create-new/osago',
          '/worksheet/:id/home',
          '/worksheet/:id/calculator',
          '/worksheet/:id/loan-issue',
          '/worksheet/:id/assistance',
          '/worksheet/:id/insurance',
          '/worksheet/:id',
        ]}
        render={renderRouteChildren}
      />
    </Switch>
  );
};
